import { render, staticRenderFns } from "./AboutOnlineRecruits.vue?vue&type=template&id=3572abaa"
import script from "./AboutOnlineRecruits.vue?vue&type=script&lang=js"
export * from "./AboutOnlineRecruits.vue?vue&type=script&lang=js"
import style0 from "./AboutOnlineRecruits.vue?vue&type=style&index=0&id=3572abaa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports